export function isEmpty(node) {
  return node === undefined || node == null || node === "" || node.length === 0;
}
